import EN from '../../EN.json';
import request from "./request";

export const isEmpty = obj => {
  for (const key in obj) {
    if (obj[key] !== null && obj[key] != '') return false;
  }
  return true;
};

export const isSequentialOrRepeatable = value => {
  if (!value) {
    return true;
  };
  let isSequential = false;
  value.split('').forEach((_val, index) => {
    const subStr = value.substr(index, value.length);
    for (let i = 3, len = subStr.length; i < len; i += 1) {
      if (
        subStr[i - 3].charCodeAt(0) === subStr[i - 2].charCodeAt(0) - 1 && subStr[i - 2].charCodeAt(0) === subStr[i - 1].charCodeAt(0) - 1 &&
        subStr[i - 1].charCodeAt(0) === subStr[i].charCodeAt(0) - 1
      ) {
        isSequential = true;
      }
    }
  });
  return !(/(.)\1{2,}/g.test(value) || isSequential);

};
export const getLocale = () => {
  // localStorage.getItem('LOCALE');
  return EN;
};

export const setLocale = (locale) => {
  // localStorage.setItem('LOCALE', locale);
};

export const setItem = (key, val) => {
  localStorage.setItem(key, JSON.stringify(val));
};
export const getItemValue = (key) => {
  localStorage.getItem(key);
};
export const removeItem = (key) => {
  localStorage.removeItem(key);
};

export const checkProperties = (obj) => {
  if (Object.entries(obj).length === 0) {
    return true;
  }
  for (const key in obj) {
    if (obj[key] !== undefined)
      return false;
  }
  return true;
};

const checkIfObjectEmpty = (obj) => {
  let isValid = false;
  if (obj) {
    isValid = Object.keys(obj).length > 0;
  }
  return isValid;
};
export const channelFields = (type = '') => {
  let isFieldAllowed = false;
  const { channel = '' } = request.getProfile() || {};
  const businessChannelsList = ['CSD', 'NBD', 'ADT'];
  const customerChannelsList = [...businessChannelsList, 'Home Solutions'];
  const pages = {
    customerInformation: 'customerInformation',
    businessInformation: 'businessInformation'

  };

  if (type === pages.customerInformation) {
    if (channel && channel.name) {
      isFieldAllowed = customerChannelsList.includes(channel.name);
    }
  }
  if (type === pages.businessInformation) {
    if (channel && channel.name) {
      isFieldAllowed = businessChannelsList.includes(channel.name);
    }
  }
  return isFieldAllowed;
};

export const compareNonAscii = (source, str) => {
  if (source === undefined) return
  const sourceAsArr = Array.isArray(source) ? source : [source];
  const nonAsciiRegex = /[^\x00-\x7F]|[ ]/g;
  return (sourceAsArr || []).find(reason => {
    return reason.replace(nonAsciiRegex, '') === str.replace(nonAsciiRegex, '')
  });
}